import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import Footer from '../../commons/Footer';
import { ReactComponent as IconRegistries } from '../../images/icn_anagrafiche.svg';
import SearchAddCont from '../../commons/SearchAddCont';
import './Profiles.scss';
import {
  ContFilterYear,
  ContPaginationPage,
  VerticalSpacing20,
} from '../../styled-components';
import { Row, Col, Label, FormGroup, CustomInput, Form } from 'reactstrap';
import Table from './Table';
import { ProfileStatus } from '../../lib/constants';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import variables from '../../variables';
import { refactoringAdminLevels } from '../../lib/helpers/refactoringAdminLevels';
import SearchInput from '../../commons/SearchInput';

function ProfilesPresentational(props) {
  const [t] = useTranslation('CONTACTS');

  const {
    data,
    total = 0,
    query = {},
    onFilter,
    isLoading = false,
    profileTypesCount = {},
    managers = [],
  } = props;

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:REGISTRIES')}
            icon={<IconRegistries fill={variables.white} />}
          />
        </section>
        <section>
          <Row>
            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:TITLE_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectYear"
                        name="year"
                        value={query.type || ''}
                        onChange={(e) => onFilter({ type: e.target.value })}
                      >
                        <option value="">Tutti</option>
                        {profileTypesCount.map((elem) => (
                          <option value={elem.type} key={elem.type}>
                            {t(refactoringAdminLevels(elem.type)) +
                              ' - ' +
                              elem.count}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>
                      {t('CONTACTS:ACTIVE_AFFILIATION_FILTER_TYPE')}
                    </Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectAffiliationStatus"
                        name="affiliationStatus"
                        value={query.affiliationStatus || ''}
                        onChange={(e) =>
                          onFilter({ affiliationStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="ACTIVATED">Attiva</option>
                        <option value="NOT_ACTIVATED">Non attiva</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width select-wrapper">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:ACTIVE_USER_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectProfileStatus"
                        name="profileStatus"
                        value={query.profileStatus || ''}
                        onChange={(e) =>
                          onFilter({ profileStatus: e.target.value })
                        }
                      >
                        <option value="">Tutti</option>
                        {ProfileStatus.map((type) => (
                          <option value={type} key={type}>
                            {t(type)}
                          </option>
                        ))}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="4" lg="4">
              <div className="row search-add-cont">
                <div className="col-sm-12" style={{ marginBottom: '10px' }}>
                  <SearchInput
                    onFilter={onFilter}
                    query={query}
                    label={t('COMMON:SEARCH')}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <VerticalSpacing20>
            <Table
              data={data}
              total={total}
              query={query}
              onFilter={onFilter}
              isLoading={isLoading}
              managers={managers}
            />
          </VerticalSpacing20>

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default withRouter(ProfilesPresentational);
